jQuery(function ($) {
  const sections = $('[data-search]');

  $.each(sections, function () {
    const section = $(this);
    const results = section.find('.vldocs-search-results article');
    const input   = {
      search      : section.find('#vldocs-search-text'),
      products    : section.find('#vldocs-search-products'),
      versions    : section.find('#vldocs-search-versions'),
      chapter     : section.find('#vldocs-search-chapter'),
    };

    // wrap search field for styling
    input.search.wrap('<div class="vldocs-search-input"></div>');

    // add placeholder text
    input.search.attr('placeholder', section.data('search').placeholder);

    // add submit button
    $('<button type="submit" tabindex="0">Search</button><div class="loader"></div>').insertAfter(input.search);

    // link to result if clicked on container
    results.on('click', function () {
      $(this).find('a').trigger('click');
    });

    // focus input on load if visible (can be hidden on vlDocs details page) and no search results are displayed
    if (input.search.is(':visible') && results.length === 0) {
      input.search.focus();
    }

    // set tabindex for fields
    $(input).each(function () {
      $(this).attr('tabindex', 0);
    });

    // trigger change if products have initial value after reload
    if (input.products.val() !== '' && input.versions.val() === '' && input.chapter.val() === '') {
      input.products.trigger('change');
    }

    // place navigation inside results container and clone to bottom
    const nav = section.find('.vldocs-results-nav');

    if (nav.length) {
      section.find('.searchResults-count').append(nav);
      nav.clone().insertAfter(section.find('.searchResults'));
    }
  });
});
